
import AxiosAPI from "./AxiosAPI";


export const fetchPrintConfig = async (StoreId) => {
  try {
    const response = await AxiosAPI.get(`/setup/printconfig/${StoreId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleAddPrintConfig = async (data) => {
  try {
    const response = await AxiosAPI.post("/setup/store/printconfig", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add print config:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditPrintConfig= async (key, data) => {
  try {
    const response = await AxiosAPI.put(
      `/setup/stores/printconfig/${key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};



export const deletePrintConfig = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `/setup/stores/printconfig/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};

